import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/apiClient";
import { toast } from "sonner";
import { History, RefreshCw } from "lucide-react";

const FIELD_PT = {
  contactos: "contactos", reunioes: "reuniões", angariacoes: "angariações", vendas: "vendas",
  social_posts: "posts sociais", humanized_videos: "vídeos", formacoes: "formações",
  growth_shares: "growth share externo", growth_shares_internal: "growth share interno",
  presente: "presença", pontual: "pontualidade", tpc: "TPC", reporting: "reporte", points: "pontos",
};

const val = (v) => (v === true ? "sim" : v === false ? "não" : v === null || v === undefined ? "—" : String(v));

const KIND_PT = { daily: "registo diário", weekly: "registo semanal", weekly_deleted: "registo apagado" };

export const EntryAuditLog = () => {
  const [rows, setRows] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = () => {
    setBusy(true);
    api.get("/entry-audit?limit=60").then((r) => setRows(r.data.changes))
      .catch((e) => toast.error(formatApiError(e)))
      .finally(() => setBusy(false));
  };
  useEffect(load, []);

  return (
    <div className="kw-card p-5" data-testid="entry-audit">
      <div className="flex items-center gap-3 mb-1">
        <History className="w-4 h-4 text-[#E50000]" />
        <div className="kw-overline flex-1">Rasto de alterações de pontos</div>
        <button onClick={load} disabled={busy} className="kw-btn-secondary !py-1 !px-2 text-[10px] inline-flex items-center gap-1"
          data-testid="entry-audit-refresh"><RefreshCw className={`w-3 h-3 ${busy ? "animate-spin" : ""}`} /> Atualizar</button>
      </div>
      <p className="text-[11px] text-[#737373] mb-3">Quem alterou os registos diários e semanais, o que mudou e quando.</p>
      {rows === null && <div className="text-sm text-[#737373]">A carregar…</div>}
      {rows?.length === 0 && <div className="text-sm text-[#737373]" data-testid="entry-audit-empty">Ainda não há alterações registadas.</div>}
      <div className="divide-y divide-[#161616] max-h-[420px] overflow-y-auto">
        {(rows || []).map((r) => (
          <div key={r.id} className="py-3 text-sm" data-testid={`entry-audit-${r.id}`}>
            <div className="flex flex-wrap items-baseline gap-2">
              <span className="font-bold">{r.player_name || r.player_id}</span>
              <span className="text-[10px] uppercase tracking-widest text-[#737373]">
                {KIND_PT[r.kind] || r.kind}{r.date ? ` · ${r.date}` : r.week_number ? ` · semana ${r.week_number}` : ""}
              </span>
              <span className="flex-1" />
              <span className="text-[11px] text-[#A3A3A3]">
                {r.by_name || "—"}{r.by_role ? ` (${r.by_role})` : ""} · {new Date(r.at).toLocaleString("pt-PT")}
              </span>
            </div>
            <div className="text-[11px] text-[#A3A3A3] mt-1">
              {Object.entries(r.changes || {}).map(([f, [a, b]]) => (
                <span key={f} className="mr-3">{FIELD_PT[f] || f}: <span className="text-[#737373]">{val(a)}</span> → <b className="text-white">{val(b)}</b></span>
              ))}
              {Object.keys(r.changes || {}).length === 0 && <span>registo criado</span>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
